import { ZodIssue } from 'zod';

export type ValidationError = {
  error: {
    message?: string;
    reason: string;
    details?: ZodIssue[];
  };
};

export type CheckoutErrorResponse = ValidationError & { unbindAppInstance: boolean };

export function error(reason: string, message?: string, issues?: ZodIssue[]): ValidationError {
  const error: ValidationError = {
    error: {
      reason
    }
  };

  if (message) {
    error.error.message = message;
  }

  if (issues) {
    error.error.details = issues;
  }

  return error;
}

export function invalidParam(issues: ZodIssue[]) {
  const firstIssue = issues[0];

  if (firstIssue.code === 'custom') {
    return error('INVALID_PARAMETER', firstIssue.message, issues);
  }

  let message = 'Invalid parameter: ';

  if (firstIssue.message === 'Required') {
    message += `"${firstIssue.path.join('.')}" is required`;
  } else if (firstIssue.path.length) {
    message += `"${firstIssue.path.join('.')}". ${firstIssue.message}`;
  } else {
    message += `${firstIssue.message}`;
  }

  return error('INVALID_PARAMETER', message, issues);
}
